import * as Sentry from '@sentry/react';
import { AxiosError } from 'axios';

interface CaptureExceptionArgs {
  error: unknown;
  sensitive?: boolean;
  context?: Record<string, unknown>;
  redactedData?: Record<string, unknown>;
}

export const captureException = ({
  error,
  sensitive,
  context,
  redactedData,
}: CaptureExceptionArgs) => {
  if (error instanceof AxiosError) {
    const redactedRequestBody = redactedData ?? '[REDACTED]';

    return Sentry.captureException(error, {
      extra: {
        requestBody: sensitive
          ? redactedRequestBody
          : JSON.stringify(error.config?.data, null, 2),
        requestResponse: JSON.stringify(error.response?.data, null, 2),
        ...context,
      },
    });
  }

  return Sentry.captureException(error, context && { extra: context });
};
